import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TopographyViewControllerDelegate, TopographyViewController } from "../../Screen/Topography/TopographyViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { TopographyViewModel } from '../../Screen/Topography/TopographyViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class TopographyCoordinator implements IndexCoordinatorDelegate, TopographyViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geptopografia")
        return (<ProtectedRoute path="/:base/topografia" exact={true} component={(props: any) => {
            return (<TableGenericViewController 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Topografia"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new TopographyViewModel()
        return (<ProtectedRoute path="/:base/topografia/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<TopographyViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geptopografia") {
            navigation.history.push(`topografia/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geptopografia") {
            navigation.history.push(`topografia/cad/${idSelection}`);
            return;
        }
    }

}